/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: Han bei
 * @Last Modified time: 2019-07-18 16:35:58
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */




import React, { Component } from 'react';
import Compared from "./Compared";
import { InputNumber, Input } from 'antd';

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class TableText extends Component {
    render() {
        const { text, index, type, name, onChange, totalIndex = [], warn } = this.props.data;
        const { title = [], record = {}, sqlName = "" } = this.props.data.compared || {};
        switch (type) {
            case 'input':
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                onChange(name, value, index)
                            }}
                        />
                    </div>
                )
                break;
            case 'number':
                if (this.props.data.compared) {
                    if (warn) {
                        return (
                            <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-text-warn" : ""} `} >
                                    <span style={{ color: "red" }}>
                                        {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </span>
                                </div>
                            </Compared >
                        )
                    }
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}  `} >
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </Compared >
                    )
                }

                if (warn) {
                    return (
                        <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-text-warn" : ""}  `} >
                            <span style={{ color: "red" }}>
                                {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </span>
                        </div>
                    )
                }
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}  `} >
                        {Number(text || '0') < 0 ?
                            <span style={{ color: "red" }}>
                                ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                            :
                            Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                    </div>
                )
                break;
            case 'inputPercent':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "percent" }} >
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    defaultValue={Number(text || "0") * 100 || ""}
                                    className="table_numInput"
                                    precision={1}
                                    formatter={value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => {
                                        let parseValue = value;
                                        parseValue = value.replace('%', '').replace(/\$\s?|(,*)/g, '')
                                        return parseValue
                                    }}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/%|,/g, '') || '0');
                                        value = Number(value.toFixed(1) / 100).toFixed(3);
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                defaultValue={Number(text || "0") * 100 || ""}
                                className="table_numInput"
                                precision={1}
                                formatter={value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => {
                                    let parseValue = value;
                                    parseValue = value.replace('%', '').replace(/\$\s?|(,*)/g, '')
                                    return parseValue
                                }}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/%|,/g, '') || '0');
                                    value = Number(value.toFixed(1) / 100).toFixed(3);
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'inputNumber':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "number" }} >
                            <div className={`table-padding table-color-number ${warn ? "table-inputNumber-err" : ""}`}>
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding table-color-number ${warn ? "table-inputNumber-err" : ""}`} >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'percent':
                // 百分比位数根据传值进行变动
                const num = (text.toString().split('.')[1] || "").length <= 3 ? 1 : (text.toString().split('.')[1] || "").length - 2;

                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, type: "percent" }} >
                            <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({((Math.abs(text) * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (Math.abs(text) * 100).toFixed(num).toLocaleString()) + '%'})</span> : ((text * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (text * 100).toFixed(num).toLocaleString()) + '%'}
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                            {Number(text) < 0 ? <span style={{ color: "red" }}>({((Math.abs(text) * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (Math.abs(text) * 100).toFixed(num).toLocaleString()) + '%'})</span> : ((text * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (text * 100).toFixed(num).toLocaleString()) + '%'}
                        </div>
                    )
                }

                break;
            case 'text':
                if (warn) {
                    return (
                        <div className={`table-padding ${warn ? "table-text-warn" : ""}  `} style={{ textAlign: "left" }} >
                            <span style={{ color: "red", }} dangerouslySetInnerHTML={{ __html: text || "-" }}>

                            </span>
                        </div>
                    )
                }
                return (
                    <div
                        className={`table-padding  ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}
                        style={{ textAlign: "left" }}
                        dangerouslySetInnerHTML={{ __html: text || "-" }}
                    >

                    </div>
                )
                break;

            default:
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "center" }}>
                        -
                    </div>
                )
                break;
        }
    }
}

export default TableText;


// WEBPACK FOOTER //
// ./src/hr/components/TableText.js